import { useEffect, useState } from "react";

import { Grid, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";

import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { X } from "react-feather";
import useMediaQuery from "@mui/material/useMediaQuery";
import subscriptionService from "../../services/subscriptionPlan";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import moment from "moment";
import ConfirmationBox from "../../common/ConfirmationBox";

const CancelButton = styled(Button)({
  height: "44px",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
  background: "#FFFFFF",
  border: "1px solid #1A2842",
  boxSizing: "border-box",
  color: "#1A2842",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  borderRadius: "5px",
  fontFamily: ["Poppins"].join(","),
  "&:hover": {
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  "&:active": {
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#FFFFFF",
  },
  "&:focus": {
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
});

const ConfirmSubscriptionCancellationButton = styled(Button)({
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  textTransform: "none",
  fontSize: "14px",
  padding: "10px 20px",
  border: "none",
  fontWeight: 400,
  lineHeight: "24px",
  backgroundColor: "#1A2842",
  color: "white",
  fontFamily: ["Poppins"].join(","),
  "&:hover": {
    backgroundColor: "#1A2842",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  "&:active": {
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#1A2842",
  },
  "&:focus": {
    backgroundColor: "#1A2842",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  },
  "&:disabled": {
    color: "white",
    backgroundColor: "#8C94A0;",
  },
});

export default function ManageReportModal(props) {
  const {
    open,
    handleClose,
    currentQuantity,
    subscription,
    refreshSubscription,
    currentPlan,
    reportStatics,
  } = props;
  const [quantity, setQuantity] = useState(currentQuantity);
  const [previewInvoice, setPreviewInvoice] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const smallDeviceMatch = !useMediaQuery("(min-width:656px)");
  const stripeData = JSON.parse(currentPlan?.stripeData);

  console.log("sssssssssssssssssssssssss", subscription);

  const useStyles = makeStyles((theme) => ({
    moneyGPSAlert: {
      backgroundColor: "#ECEFF1",
    },
    moneyGPSAlertTitle: {
      fontWeight: "bold",
      fontSize: "16px",
    },
    subSummaryColumn: {
      color: "#2162A5",
      fontWeight: "bold",
    },
    subSummaryColumnValue: {
      textTransform: "capitalize",
      fontSize: "24px",
      fontWeight: "bold",
      marginTop: theme.spacing(1),
    },
    tableHeader: {
      fontWeight: "bold",
      backgroundColor: "#FAFAFA",
    },
    checkCircle: {
      fontSize: "28px",
      color: "#2AD000",
    },
    referralCodeTitle: {
      fontWeight: "bold",
    },
    referralCode: {
      fontWeight: "bold",
      color: "#2162A5",
      fontSize: "26px",
    },
    usedReports: {
      color: "#2162A5",
    },
    // TODO: Make generic confirm modal dialog and move the styles to the new component:
    // [START] Modal styles
    bglConsentBox: {
      padding: "32px",
      position: "absolute",
      backgroundColor: "#FFFFFF",
      boxShadow: "4px 4px 6px rgba(0, 0, 0, 0.25)",
      borderRadius: "5px",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      minHeight: "486px",
      width: "865px",
      maxHeight: "60%",
      overflowX: "hidden",
      overflowY: "auto",
    },
    confirmLbl: {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "24px",
      lineHeight: "32px",
      color: "#000000",
      marginBlock: 0,
      marginBottom: 32,
    },
    text14: {
      fontFamily: "Poppins",
      fontStyle: "small",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "24px",
    },
    crossIcon: {
      position: "absolute",
      right: "24px",
      cursor: "pointer",
    },
    errorText: {
      fontSize: "15px",
      background: "#fafafa",
      display: "flex",
      alignItems: "center",
      border: "1px solid #ec0018",
      borderLeft: "9px solid #ec0018",
      borderRadius: "5px",
      // gap: "15px",
      padding: "5px 15px",
      margin: "0 80px",
    },
    // [END] Modal styles
  }));
  const classes = useStyles();

  async function fetchData() {
    try {
      setErrorMessage("");
      setIsFetching(true);
      const previewInvoiceRes =
        await subscriptionService.manageSubscriptionReport({
          type: "preview",
          body: {
            quantity: quantity,
          },
        });

      const preInvoice = JSON.parse(previewInvoiceRes);

      console.log("preInvoice----------------", preInvoice);

      setIsFetching(false);
      if (preInvoice && preInvoice.statusCode === 200) {
        setPreviewInvoice(preInvoice.body.invoice);
        setInvoiceData(preInvoice.body);
      } else {
        setErrorMessage(preInvoice?.error?.message || "Something went wrong");
        setPreviewInvoice(null);
        setInvoiceData(null);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setErrorMessage("Error in fetching data for new quantity");
      setPreviewInvoice(null);
      setInvoiceData(null);
      setIsFetching(false);
    }
  }

  const confirmUpdate = async () => {
    try {
      setErrorMessage("");
      setIsUpdating(true);
      const subscriptionRes =
        await subscriptionService.manageSubscriptionReport({
          type: "confirm",
          body: {
            quantity: quantity,
            prorationDate: invoiceData.prorationDate,
          },
        });

      const newSubscription = JSON.parse(subscriptionRes);

      console.log("newSubscription----------------", newSubscription);

      if (newSubscription && newSubscription.statusCode === 200) {
        setTimeout(() => {
          window.alert("Subscription updated successfully.");
          setIsUpdating(false);
          refreshSubscription();
          handleClose(false);
        }, 3000);
      } else {
        setIsUpdating(false);
        window.alert(newSubscription?.error?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error updating subscription:", err);
      setErrorMessage("Error in updating subscription");
      setIsUpdating(false);
    }
  };

  //this handles input change and validations
  const handleInputChange = (event) => {
    let value = event.target.value;

    value = value.replace(/^0+/, "") || "0";

    if (/^\d*$/.test(value)) {
      setQuantity(value === "0" ? "" : Number(value));
    }
  };

  function toCurrencyFormat(value) {
    if (value === null || value === undefined) {
      return "";
    }

    const numberValue = Number(value);
    if (isNaN(numberValue)) {
      return "";
    }

    // Convert cents to dollars
    const scaledValue = numberValue / 100;

    // Format the absolute dollar value with two decimals and locale-aware separators
    const formattedNumber = Math.abs(scaledValue).toLocaleString("en-AU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    // Prepend the custom currency prefix, taking account of negatives
    // const prefix = scaledValue < 0 ? "-A$" : "A$";
    const prefix = scaledValue < 0 ? "-$" : "$";
    return prefix + formattedNumber;
  }

  function formatDateRange({ start, end }) {
    // Convert epoch seconds into JavaScript Date objects (multiplying by 1000)
    const startDate = new Date(start * 1000);
    const endDate = new Date(end * 1000);

    // Format the start date: abbreviated month and day
    const startMonth = startDate.toLocaleString("en-US", { month: "short" });
    const startDay = startDate.getDate();

    // Format the end date: abbreviated month, day and full year
    const endMonth = endDate.toLocaleString("en-US", { month: "short" });
    const endDay = endDate.getDate();
    const endYear = endDate.getFullYear();

    // Combine both into a single string output
    return `${startMonth} ${startDay} - ${endMonth} ${endDay}, ${endYear}`;
  }

  const getUnitPrice = (quantity) => {
    const priceList = JSON.parse(subscription.tiers);
    const range = priceList.find(
      (range) => quantity >= range.min && quantity <= range.max
    );
    return range ? range.price : 0;
  };

  const isRefundable = (billingCycle, stripeData) => {
    let refundable = true;

    //Check if subscription plan is yearly
    if (!(billingCycle === "yearly")) {
      refundable = false;
    }

    // Check if subscription have last month of renewal.
    const now = Date.now(); // Current time in milliseconds
    const periodEndTime = stripeData.current_period_end * 1000; // Convert to milliseconds

    const diffInMs = now - periodEndTime;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (!(diffInDays >= 0 && diffInDays <= 30)) {
      refundable = false;
    }

    return refundable;
  };

  // Confirmation box handlers
  const handleConfirm = () => {
    console.log("Confirmed!");
    setOpenConfirm(false);
    confirmUpdate();
  };

  const handleCancel = () => {
    console.log("Canceled.");
    setOpenConfirm(false);
  };
  // Confirmation box handlers

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={classes.bglConsentBox}
          sx={{ width: `${smallDeviceMatch ? "calc(100% - 32px)" : "838px"}` }}
        >
          <X className={classes.crossIcon} onClick={() => handleClose(false)} />
          <Grid mt={2}>
            <Typography
              className={classes.confirmLbl}
              style={{ textAlign: "center" }}
            >
              Manage Reports
            </Typography>
          </Grid>

          <Typography sx={{ paddingLeft: "15px", fontWeight: "bold" }}>
            Current details:
          </Typography>

          <Grid
            container
            sx={{
              alignItems: "center",
            }}
            spacing={2}
            mt={1}
          >
            <Grid
              item
              sx={{
                textAlign: "center",
              }}
              xs={4}
            >
              <Typography sx={{ fontWeight: "bold", padding: "2px" }}>
                Billing Cycle
              </Typography>
              <Typography>{subscription.term}</Typography>
            </Grid>
            <Grid
              item
              sx={{
                textAlign: "center",
              }}
              xs={4}
            >
              <Typography sx={{ fontWeight: "bold", padding: "2px" }}>
                Quantity
              </Typography>
              <Typography>{currentQuantity}</Typography>
            </Grid>
            <Grid
              item
              sx={{
                textAlign: "center",
              }}
              xs={4}
            >
              <Typography sx={{ fontWeight: "bold", padding: "2px" }}>
                Price
              </Typography>
              <Typography>{`$${
                (stripeData.upcomingInvoice.total ||
                  stripeData?.currentInvoice.total) / 100
              }`}</Typography>
            </Grid>
          </Grid>

          <Grid container alignItems="center" spacing={2} mt={4}>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontStyle: "small",
                  fontWeight: "bold",
                  Padding: "2px",
                  fontSize: "16px",
                  textAlign: "right",
                }}

                // style={{ fontWeight: "bold", marginBottom: "5px" }}
              >
                New Quantity
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Quantity"
                variant="standard"
                fullWidth
                onChange={handleInputChange}
                value={quantity}
                sx={{
                  marginBottom: "20px",
                  backgroundColor: "#FFFFFF",
                  width: "100%",
                  lineHeight: "15px",
                }}
                error={
                  quantity !== "" &&
                  (quantity < subscription.minQuantity ||
                    quantity > subscription.maxQuantity)
                }
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  min: subscription.minQuantity,
                  max: subscription.maxQuantity,
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <ConfirmSubscriptionCancellationButton
                variant="contained"
                style={{ marginLeft: "15px" }}
                onClick={() => fetchData()}
                disabled={
                  quantity < subscription.minQuantity ||
                  quantity > subscription.maxQuantity ||
                  isFetching
                }
              >
                Request a Quote
              </ConfirmSubscriptionCancellationButton>
            </Grid>
          </Grid>
          <Grid container alignItems="center" spacing={2} mt={1}>
            <Grid item xs={12}>
              {quantity < subscription.minQuantity ||
              quantity > subscription.maxQuantity ||
              errorMessage ? (
                <Typography
                  variant="body2"
                  component="span"
                  className={classes.errorText}
                >
                  {!errorMessage
                    ? `Quantity must be between ${subscription.minQuantity} and ${subscription.maxQuantity}`
                    : errorMessage}
                </Typography>
              ) : null}
            </Grid>
          </Grid>

          {isFetching ? (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{ mt: 3, mb: 3 }}
            >
              <CircularProgress />
            </Grid>
          ) : null}

          {!isFetching && previewInvoice ? (
            <Grid>
              <Box
                sx={{
                  maxWidth: 800,
                  fontFamily: "sans-serif",
                  mx: "auto",
                  p: 2,
                }}
              >
                {/* Heading */}
                <Typography variant="h6" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: "bold" }}>
                    {toCurrencyFormat(previewInvoice.amount_due)}
                  </span>{" "}
                  {" due "}
                  {previewInvoice.next_payment_attempt
                    ? moment
                        .unix(previewInvoice.next_payment_attempt)
                        .format("MMMM D, YYYY")
                    : moment().format("MMMM D, YYYY")}
                </Typography>

                {/* Invoice Details Table */}
                <TableContainer component={Paper}>
                  <Table
                    sx={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontFamily: "arial, sans-serif",
                    }}
                    aria-label="invoice table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            // width: "250px",
                            textAlign: "left",
                            paddingLeft: 0,
                            borderBottom: "2px solid #000",
                            padding: "8px 0 8px 20px",
                            fontSize: "14px",
                            fontWeight: "normal",
                          }}
                        >
                          Description
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            borderBottom: "2px solid #000",
                            padding: "8px 0 8px 20px",
                            fontSize: "14px",
                            fontWeight: "normal",
                            width: "100px",
                          }}
                        >
                          Qty
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            borderBottom: "2px solid #000",
                            padding: "8px 0 8px 20px",
                            fontSize: "14px",
                            fontWeight: "normal",
                            width: "100px",
                          }}
                        >
                          Unit price
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "right",
                            borderBottom: "2px solid #000",
                            padding: "8px 0 8px 20px",
                            fontSize: "14px",
                            fontWeight: "normal",
                            width: "150px",
                          }}
                        >
                          Amount
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* Row 1 */}
                      {previewInvoice.lines.data.map((item, index) => {
                        return (
                          <TableRow>
                            <TableCell
                              sx={{
                                textAlign: "left",
                                paddingLeft: 0,
                                borderBottom: "1px solid #dddddd",
                                padding: "8px 0 24px 20px",
                              }}
                            >
                              <Typography variant="body2">
                                {item.description}
                              </Typography>
                              <Typography variant="body2">
                                {formatDateRange(item.period)}
                              </Typography>
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                borderBottom: "1px solid #dddddd",
                                padding: "8px 0 24px 20px",
                              }}
                            >
                              {item.quantity}
                            </TableCell>
                            <TableCell
                              sx={{
                                textAlign: "center",
                                borderBottom: "1px solid #dddddd",
                                padding: "8px 0 24px 20px",
                              }}
                            />
                            <TableCell
                              sx={{
                                textAlign: "right",
                                borderBottom: "1px solid #dddddd",
                                padding: "8px 0 24px 20px",
                              }}
                            >
                              {toCurrencyFormat(item.amount || 0)}
                            </TableCell>
                          </TableRow>
                        );
                      })}

                      {/* Unit Price Row */}
                      <TableRow sx={{ opacity: 0.5 }}>
                        <TableCell
                          sx={{
                            textAlign: "left",
                            padding: "8px 8px 16px 20px",
                          }}
                        >
                          Updated Subscription Price
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            padding: "8px 0 16px 20px",
                          }}
                        >
                          {quantity}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                            padding: "8px 0 16px 20px",
                          }}
                        >
                          A${getUnitPrice(quantity) || "0.00"}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "right",
                            padding: "8px 0 16px 20px",
                          }}
                        >
                          {toCurrencyFormat(
                            quantity * getUnitPrice(quantity) * 100
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Summary Table */}
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}
                >
                  <TableContainer
                    component={Paper}
                    sx={{ maxWidth: 400, width: "100%" }}
                  >
                    <Table
                      sx={{ borderCollapse: "collapse" }}
                      aria-label="summary table"
                    >
                      <TableBody>
                        <TableRow>
                          <TableCell
                            sx={{
                              borderTop: "1px solid #ddd",
                              padding: "4px 0",
                            }}
                          >
                            Subtotal
                          </TableCell>
                          <TableCell
                            sx={{
                              borderTop: "1px solid #ddd",
                              padding: "4px 0",
                              textAlign: "right",
                            }}
                          >
                            {toCurrencyFormat(previewInvoice.subtotal)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              borderTop: "1px solid #ddd",
                              padding: "4px 0",
                            }}
                          >
                            Total
                          </TableCell>
                          <TableCell
                            sx={{
                              borderTop: "1px solid #ddd",
                              padding: "4px 0",
                              textAlign: "right",
                            }}
                          >
                            {toCurrencyFormat(previewInvoice.total)}
                          </TableCell>
                        </TableRow>
                        {previewInvoice.amount_due === 0 &&
                        previewInvoice.total < 0 ? (
                          <TableRow>
                            <TableCell
                              sx={{
                                borderTop: "1px solid #ddd",
                                // fontWeight: "bold",
                                padding: "4px 0",
                              }}
                            >
                              Applied balance
                            </TableCell>
                            <TableCell
                              sx={{
                                borderTop: "1px solid #ddd",
                                // fontWeight: "bold",
                                padding: "4px 0",
                                textAlign: "right",
                              }}
                            >
                              {toCurrencyFormat(Math.abs(previewInvoice.total))}
                            </TableCell>
                          </TableRow>
                        ) : null}
                        <TableRow>
                          <TableCell
                            sx={{
                              border: "none",
                              fontWeight: "bold",
                              padding: "4px 0",
                            }}
                          >
                            Amount due
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "none",
                              fontWeight: "bold",
                              padding: "4px 0",
                              textAlign: "right",
                            }}
                          >
                            {toCurrencyFormat(previewInvoice.amount_due)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>

              <Grid
                container
                // justifyContent="center"
                spacing={3}
                // alignItems="center"
                // mt={4}
                sx={{ mt: 2, mb: "8px", paddingLeft: "20px" }}
              >
                <Grid item>
                  <Typography sx={{ fontSize: "16px", mb: 1 }}>
                    <span style={{ fontWeight: "bold" }}>Note: </span>
                  </Typography>
                  {previewInvoice.amount_due === 0 &&
                  previewInvoice.total < 0 ? (
                    <Typography sx={{ fontSize: "16px", mb: 1 }}>
                      The balance of{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {toCurrencyFormat(Math.abs(previewInvoice.total))}
                      </span>{" "}
                      will be{" "}
                      {isRefundable(subscription.term, stripeData)
                        ? "refunded to your account."
                        : "adjusted in your next invoice."}
                    </Typography>
                  ) : null}

                  {previewInvoice.amount_due > 0 && (
                    <Typography
                      sx={{ fontSize: "15px", mb: 1 /* marginLeft: "50px" */ }}
                    >
                      Proration amount{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {toCurrencyFormat(previewInvoice.amount_due)}
                      </span>{" "}
                      will be charged{" "}
                      {reportStatics.used < quantity
                        ? `immediately.`
                        : ` in next invoice.`}
                      {/* {reportStatics.used < quantity
                      ? previewInvoice.amount_due > 0
                        ? `Proration amount ${toCurrencyFormat(
                            previewInvoice.amount_due
                          )} will be charged immediately.`
                        : null
                      : `Proration amount ${toCurrencyFormat(
                          previewInvoice.amount_due
                        )} will be charged in next invoice.`} */}
                    </Typography>
                  )}
                  <Typography sx={{ fontSize: "15px" }}>
                    By confirming, your current plan will be updated to include
                    a total of{" "}
                    <span style={{ fontWeight: "bold" }}>{quantity}</span>{" "}
                    reports.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ) : null}

          <Grid
            container
            justifyContent="center"
            spacing={3}
            alignItems="center"
            mt={3}
          >
            <Grid item>
              <CancelButton
                variant="contained"
                onClick={() => handleClose(false)}
              >
                Cancel
              </CancelButton>
            </Grid>
            <Grid item>
              <ConfirmSubscriptionCancellationButton
                variant="contained"
                style={{ marginRight: "8px" }}
                onClick={() => setOpenConfirm(true)}
                disabled={
                  !previewInvoice ||
                  isUpdating ||
                  quantity < subscription.minQuantity ||
                  quantity > subscription.maxQuantity ||
                  errorMessage
                }
              >
                {isUpdating ? (
                  <CircularProgress size={22} sx={{ marginRight: "8px" }} />
                ) : null}
                Confirm
              </ConfirmSubscriptionCancellationButton>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <ConfirmationBox
        open={openConfirm}
        message="Are you sure you want to proceed?"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
}
